/* PCのメガメニューを「マウスを乗せただけ」で開く。（2026-08-31）
 *
 * Dawn標準の <details> はクリックでしか開かない。CSSだけではホバーで開けないため、
 * マウスが乗ったら open を付ける、という最小限のJSを足している。
 *
 * 気をつけていること：
 *   ① マウスが使える環境だけ（(hover: hover) and (pointer: fine)）。
 *      スマホ・タブレットのタップは今までどおりクリックで開閉する。
 *      ホバーを効かせるとタップした瞬間に開いて閉じられなくなるため。
 *   ② 閉じるのは、上部バーとパネルの両方からマウスが離れてから少し待った後。
 *      すぐ閉じると、summary とパネルの間のすき間を通るときにチラつく。
 *   ③ キーボードで開いている（中にフォーカスがある）ときは、マウスが離れても閉じない。
 *
 * 余白クリックで閉じる処理は assets/mega-menu-close.js（別ファイル）。
 */
(function () {
  const CLOSE_DELAY = 150;
  const pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  let closeTimer = null;

  function open(details) {
    if (details.hasAttribute('open')) return;
    details.setAttribute('open', '');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  function close(details) {
    // キーボード操作中は閉じない
    if (details.contains(document.activeElement)) return;

    const holder = details.closest('header-menu');
    if (holder && typeof holder.close === 'function') {
      holder.close();
      return;
    }
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function init() {
    const nav = document.querySelector('.cc-nav');
    if (!nav) return;

    const items = nav.querySelectorAll('li > header-menu > details.mega-menu');
    if (!items.length) return;

    function closeAll() {
      items.forEach(close);
    }

    items.forEach(function (details) {
      const area = details.closest('li') || details;

      area.addEventListener('mouseenter', function () {
        if (!pointer.matches) return;
        clearTimeout(closeTimer);
        items.forEach(function (other) {
          if (other !== details) close(other);
        });
        open(details);
      });

      area.addEventListener('mouseleave', function () {
        if (!pointer.matches) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(closeAll, CLOSE_DELAY);
      });
    });

    // バー全体から離れたときも閉じる（項目と項目のすき間を通って出た場合）
    nav.addEventListener('mouseleave', function () {
      if (!pointer.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, CLOSE_DELAY);
    });

    nav.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
